import React from "react";
import { Link } from "react-router-dom";
import "./MainNavbar.css";
import Nav from "react-bootstrap/Nav";

interface Props {}

const LogedOutTabs = () => {
  
  return (
    <Nav className="me-auto">
        <Nav.Link href="/">Search</Nav.Link>
    </Nav>
  );
};

export default LogedOutTabs;